


class Gyros {

	instance = {
		gamma : 0,
		beta : 0,
		alpha : 0
	}

	constructor () {
		this._addEvents()
	}

	update (event) {

		let x;
		const orientation = typeof window.orientation !== 'undefined' ? window.orientation : 0;

		// console.log(orientation)

		switch(orientation) {
			case 0 :
			case 180 :
				this.instance.gamma = event.gamma
				break;
		}

	}

	_addEvents () {

		// if ('ondeviceorientationabsolute' in window) {
		// 	console.log('test 1')
		// 	window.addEventListener('deviceorientationabsolute', this.update.bind(this),false)
		// } else if ('ondeviceorientation' in window) {
		// 	console.log('test 2')
		// 	window.addEventListener('deviceorientation', this.update.bind(this),false)
		// }
		
		// console.log('okokokokokokoko')

		// if ((window.screen.orientation) && ('onchange' in window.screen.orientation)) {
		// 	console.log('popo')
		// 	window.screen.orientation.addEventListener('change', this.update.bind(this))
		// } else if ('onorientationchange' in window) {
		// 	console.log('ok')
		// 	window.addEventListener('orientationchange', this.update.bind(this))
		// } else {
		// 	console.warn('No orientationchange events')
		// }

		window.addEventListener('deviceorientation', this.update.bind(this))

	}

}


export default new Gyros() 


// WEBPACK FOOTER //
// ./src/utils/gyros.js